'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { ControlBarActionDialog, ControlBarIframeDialog } from '@/app/[locale]/(worlds)/[roomId]/components/ControlBarActionDialog';
import IconShare from '@/components/assets/icon_share_new.svg';
import SharePanel from '@/components/SharePanel';
import ViverseButton, { type ViverseButtonProps } from '@/components/ViverseButton';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useVideoPlaybackContext } from '@/context/VideoPlaybackContext';
import { useWorldDetailsContext } from '@/context/WorldDetailsContext';
import { useEnableViewMode } from '@/hooks/useEnableViewMode';
import { buildShareUrl } from '@/lib/share-link';
import { cn } from '@/lib/utils';
import roomDefaultImage from '@/public/images/room-default.png';
type SharePopoverButtonProps = {
  className?: string;
  iconClassName?: string;
  portalContainer?: HTMLElement | null;
  size?: ViverseButtonProps['size'];
  useControlBarDialog?: boolean;
};
function SharePopoverButton(t0) {
  const $ = _c(47);
  const {
    className,
    iconClassName,
    portalContainer,
    size,
    useControlBarDialog
  } = t0;
  const t = useTranslations();
  const [isEmbedDialogOpen, setIsEmbedDialogOpen] = useState(false);
  const [isSharePanelOpen, setIsSharePanelOpen] = useState(false);
  const [currentTime, setCurrentTime] = useState();
  const {
    roomData
  } = useCheckEnterRoomContext();
  const {
    is3DCommerce,
    standaloneUrl
  } = useWorldDetailsContext();
  const enableViewMode = useEnableViewMode();
  const videoPlayback = useVideoPlaybackContext();
  const isVideoWorld = !!roomData.vod_id;
  const t1 = is3DCommerce || enableViewMode;
  let t2;
  if ($[0] !== roomData.hub_sid || $[1] !== t1) {
    t2 = buildShareUrl(roomData.hub_sid, {
      view: t1
    });
    $[0] = roomData.hub_sid;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const shareUrl = t2;
  let t3;
  if ($[3] !== isSharePanelOpen || $[4] !== isVideoWorld || $[5] !== useControlBarDialog || $[6] !== videoPlayback) {
    t3 = async () => {
      if (useControlBarDialog && isSharePanelOpen) {
        setIsSharePanelOpen(false);
        return;
      }
      if (isVideoWorld) {
        const t_0 = await (videoPlayback?.requestCurrentTime() ?? Promise.resolve(0));
        setCurrentTime(t_0 > 0 ? t_0 : undefined);
      }
      setIsSharePanelOpen(true);
    };
    $[3] = isSharePanelOpen;
    $[4] = isVideoWorld;
    $[5] = useControlBarDialog;
    $[6] = videoPlayback;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleShareClick = t3;
  let t4;
  if ($[8] !== className || $[9] !== currentTime || $[10] !== handleShareClick || $[11] !== iconClassName || $[12] !== is3DCommerce || $[13] !== isSharePanelOpen || $[14] !== isVideoWorld || $[15] !== portalContainer || $[16] !== roomData || $[17] !== shareUrl || $[18] !== size || $[19] !== standaloneUrl || $[20] !== t || $[21] !== useControlBarDialog) {
    t4 = useControlBarDialog ? <ControlBarActionDialog open={isSharePanelOpen} onOpenChange={open => {
      if (!open) {
        setIsSharePanelOpen(false);
      }
    }} portalContainer={portalContainer} trigger={<ViverseButton aria-label={t("action-list.share")} className={cn("group flex min-w-fit gap-2", className)} variant="filter" size={size} onClick={handleShareClick}><IconShare className={cn("group-hover:fill-vive-brand-50 fill-white", iconClassName)} /></ViverseButton>} closeLabel={t("media-preview-modal.close")} referenceHeight={302} className="h-[302px] items-stretch"><SharePanel shareUrl={shareUrl} title={roomData.title} info={roomData} currentTime={currentTime} isVideoWorld={isVideoWorld} is3DCommerce={is3DCommerce} isStandalone={!!standaloneUrl} previewImageAlt={roomData.title} previewImageSrc={roomData.image || roomDefaultImage.src} renderContentOnly={true} useControlBarDialog={true} onCloseAction={() => setIsSharePanelOpen(false)} onSwitchToEmbedAction={() => {
        setIsSharePanelOpen(false);
        setIsEmbedDialogOpen(true);
      }} /></ControlBarActionDialog> : <ViverseButton aria-label={t("action-list.share")} className={cn("group flex min-w-fit gap-2", className)} variant="filter" size={size} onClick={handleShareClick}><IconShare className={cn("group-hover:fill-vive-brand-50 fill-white", iconClassName)} /></ViverseButton>;
    $[8] = className;
    $[9] = currentTime;
    $[10] = handleShareClick;
    $[11] = iconClassName;
    $[12] = is3DCommerce;
    $[13] = isSharePanelOpen;
    $[14] = isVideoWorld;
    $[15] = portalContainer;
    $[16] = roomData;
    $[17] = shareUrl;
    $[18] = size;
    $[19] = standaloneUrl;
    $[20] = t;
    $[21] = useControlBarDialog;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== currentTime || $[24] !== is3DCommerce || $[25] !== isSharePanelOpen || $[26] !== isVideoWorld || $[27] !== roomData || $[28] !== shareUrl || $[29] !== standaloneUrl || $[30] !== useControlBarDialog) {
    t5 = isSharePanelOpen && !useControlBarDialog && <SharePanel shareUrl={shareUrl} title={roomData.title} info={roomData} currentTime={currentTime} positionFixed={true} isVideoWorld={isVideoWorld} is3DCommerce={is3DCommerce} isStandalone={!!standaloneUrl} onCloseAction={() => setIsSharePanelOpen(false)} />;
    $[23] = currentTime;
    $[24] = is3DCommerce;
    $[25] = isSharePanelOpen;
    $[26] = isVideoWorld;
    $[27] = roomData;
    $[28] = shareUrl;
    $[29] = standaloneUrl;
    $[30] = useControlBarDialog;
    $[31] = t5;
  } else {
    t5 = $[31];
  }
  let t6;
  if ($[32] !== currentTime || $[33] !== is3DCommerce || $[34] !== isEmbedDialogOpen || $[35] !== isVideoWorld || $[36] !== portalContainer || $[37] !== roomData || $[38] !== shareUrl || $[39] !== standaloneUrl || $[40] !== t || $[41] !== useControlBarDialog) {
    t6 = useControlBarDialog && <ControlBarIframeDialog open={isEmbedDialogOpen} onOpenChange={setIsEmbedDialogOpen} portalContainer={portalContainer} title={t("embed-modal.title")} closeLabel={t("media-preview-modal.close")}><SharePanel shareUrl={shareUrl} title={roomData.title} info={roomData} currentTime={currentTime} isVideoWorld={isVideoWorld} is3DCommerce={is3DCommerce} isStandalone={!!standaloneUrl} initialView="embed" renderContentOnly={true} useControlBarEmbedDialog={true} onCloseAction={() => setIsEmbedDialogOpen(false)} /></ControlBarIframeDialog>;
    $[32] = currentTime;
    $[33] = is3DCommerce;
    $[34] = isEmbedDialogOpen;
    $[35] = isVideoWorld;
    $[36] = portalContainer;
    $[37] = roomData;
    $[38] = shareUrl;
    $[39] = standaloneUrl;
    $[40] = t;
    $[41] = useControlBarDialog;
    $[42] = t6;
  } else {
    t6 = $[42];
  }
  let t7;
  if ($[43] !== t4 || $[44] !== t5 || $[45] !== t6) {
    t7 = <>{t4}{t5}{t6}</>;
    $[43] = t4;
    $[44] = t5;
    $[45] = t6;
    $[46] = t7;
  } else {
    t7 = $[46];
  }
  return t7;
}
export default SharePopoverButton;